export const GetReqPostConfig = () => {
    return {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + localStorage.getItem("TOKEN")
        },
        body: ''
    };
};

export const GetReqConfig = () => {
    return {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("TOKEN")
        }
    };
};